/*
 * Generic action types
 */
export const API_CALL_FAILED = "API_CALL_FAILED";

/*
 * Customer service, login action types
 */
export const ADMIN_LOGIN = "ADMIN_LOGIN";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";
export const ADMIN_LOGGED_IN = "ADMIN_LOGGED_IN";

/*
 * Customer service, customer management action types
 */
export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const RETRIEVED_CUSTOMERS = "RETRIEVED_CUSTOMERS";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const RETRIEVED_CUSTOMER = "RETRIEVED_CUSTOMER";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATED_CUSTOMER = "CREATED_CUSTOMER";
export const SAVE_CUSTOMER = "SAVE_CUSTOMER";
export const SAVED_CUSTOMER = "SAVED_CUSTOMER";

/*
 * Customer service, language management action types
 */
export const GET_LANGUAGES = "GET_LANGUAGES";
export const RETRIEVED_LANGUAGES = "RETRIEVED_LANGUAGES";
export const GET_LANGUAGE = "GET_LANGUAGE";
export const SAVE_LANGUAGE = "SAVE_LANGUAGE";
export const SAVED_LANGUAGE = "SAVED_LANGUAGE";
export const RETRIEVED_LANGUAGE = "RETRIEVED_LANGUAGE";
export const CREATE_LANGUAGE = "CREATE_LANGUAGE";
export const CREATED_LANGUAGE = "CREATED_LANGUAGE";
export const SAVE_TRANSLATION_KEYS = "SAVE_TRANSLATION_KEYS";
export const SAVED_TRANSLATION_KEYS = "SAVED_TRANSLATION_KEYS";
export const DOWNLOAD_TRANSLATIONS = "DOWNLOAD_TRANSLATIONS";
export const DOWNLOADED_TRANSLATIONS = "DOWNLOADED_TRANSLATIONS";

/*
 * Private core, login action types
 */
export const PRIVATE_CORE_LOGIN = "PRIVATE_CORE_LOGIN";
export const PRIVATE_CORE_LOGOUT = "PRIVATE_CORE_LOGOUT";
export const PRIVATE_CORE_LOGGED_IN = "PRIVATE_CORE_LOGGED_IN";

/*
 * Private core, predefined texts action types
 */
export const GET_PREDEFINED_TEXTS = "GET_PREDEFINED_TEXTS";
export const RETRIEVED_PREDEFINED_TEXTS = "RETRIEVED_PREDEFINED_TEXTS";
export const SAVE_PREDEFINED_TEXT = "SAVE_PREDEFINED_TEXT";
export const SAVED_PREDEFINED_TEXT = "SAVED_PREDEFINED_TEXT";
export const IMPORTED_PREDEFINED_TEXTS = "IMPORTED_PREDEFINED_TEXTS";

/*
 * Private core, transaction action types
 */
export const STARTED_TRANSACTION_IMPORT = "STARTED_TRANSACTION_IMPORT";
export const TRANSACTION_IMPORTED = "TRANSACTION_IMPORTED";


/*
 * Private core, valuation action types
 */
export const STARTED_VALUATION_IMPORT = "STARTED_VALUATION_IMPORT";
export const VALUATION_IMPORTED = "VALUATION_IMPORTED";


/*
 * Private core, property definition action types
 */
export const GET_PROPERTY_DEFINITIONS = "GET_PROPERTY_DEFINITIONS";
export const RETRIEVED_PROPERTY_DEFINITIONS = "RETRIEVED_PROPERTY_DEFINITIONS";



// WEBPACK FOOTER //
// ./src/redux/action-types.js